module.exports = __webpack_public_path__ + "static/img/bg-overview@t.425cb75.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hyundai-steel/bg-overview@t.jpg
// module id = 4E5n
// module chunks = 0